import "normalize.css/normalize.css";
import getOr from 'lodash/fp/getOr';

import { apiAddToCart, apiEstimateProductPrice, apiEstimateProductPriceMultiple, apiGetOrderDetail, apiGetPriceTags, apiGetProductDetail, apiGetProductSearch, apiGetProductVariants, apiTracking } from "../../utils/api";

import "./style.scss";
import { defer, embedAllTrack } from "../../utils/script";
import { urlToId } from "../../utils/slug";
import Header from "../../components/Header";
import PackageList from "./components/PackageList";
import Env from "../../environments";
import { Search } from "../../models/Search";
import { getPriceText } from "../../utils/currency";
import { LocalStorage } from "../../models/LocalStorage";
import { MINI_APP } from "../../utils/miniApp";
import SearchProductItem from "../searchProduct/components/SearchProductItem";
import { getMessage, isEmpty, isMobile, isMobileByWidth } from "../../utils/utils";
import { ROOT_GLOBAL } from "../../global/root";
import { changeQueryString, getParamUrl, historyPushState, urlFullFill } from "../../utils/url";
import { getCookie, isTouchDevice } from "../../utils/browser";
import { GLOBAL_CONSTANTS } from "../../global/constants";
import { SearchProduct } from "../../models/SearchProduct";
import { Order } from "../../models/Order";
// eslint-disable-next-line no-unused-vars
import { ProductVariant, Variant } from "../../models/ProductVariant";
import DimensionItem from "./components/DimensionItem";
import classNames from "classnames";
import AddToCartBtn from "../../components/AddToCartBtn";
import CheckoutBtn from "../../components//CheckoutBtn";
import FastCheckoutBtn from "../../components/FastCheckoutBtn";
import { addSlashes, genCKS } from "../../utils/string";
import ModalDialog from "../../components/ModalDialog";
import { FireBase } from "../../utils/firebase";
import { PriceTag } from "../../models/PriceTag";
import { Product } from "../../models/Product";
import LowestTag from "../checkoutPage/components/ProductSummary/components/LowestTag";
import { hideTooltip, setTooltip } from "../../utils/clipboard";
import { FA, GA } from "../../utils/analytic";

const DEFAULT_PER_PAGE_SEARCH = window.outerWidth < 1199 && window.outerWidth > 1023 ? 6 : window.outerWidth < 1023 ? 8 : 4;
let listPackage = [], page = 1, curDimension = {};
/** @type {SearchProduct} */ let productSearch = {};
/** @type {SearchProduct} */ let productDetail = {};
/** @type {SearchProduct} */ let productOrigin = {};
/** @type {PackageList} */ let packageItems;
/** @type {[SearchProductItem]} */ let listProductItems = [];
/** @type {AddToCartBtn} */ let addToCartBtn;
/** @type {CheckoutBtn} */ let checkoutBtn;
/** @type {FastCheckoutBtn} */ let fastCheckoutBtn;
/** @type {LowestTag} */ let lowestTag = new LowestTag({ parent: ".unit-price .lowest-price", position: "left" });

let container;
let root;
let currentOrderCode;

let dimensionItems = {}, estimateTimeout = null, isFirst = true, currentImageIndex = 0;
let isSetupCopy = false;
/** @type {Header} */ let header;

embedAllTrack();

initEvent();

function initEvent() {
  header = new Header({
    parent: ".section.section-header",
    onLoad: initData,
    onEvent: {
      onCurrency: () => window.location.reload(),
      onShipping: () => window.location.reload(),
      onLanguage: onLanguage,
    },
    fixedMetaLang: true,
    hideCurrency: false, hideShipping: false,
    hideSearch: isMobileByWidth(),
    hideNavigation: LocalStorage.isMiniApp(),
    customRightElement: true,
  });
  $(".section-compare .view-more .btn-view-more").on("click", function () {
    let products = listPackage.slice(0, 5);
    listPackage.splice(0, 5);
    if (listPackage.length > 5) {
      $(".section-compare .view-more").removeClass("hide");
    } else {
      $(".section-compare .view-more").addClass("hide");
    }
    fillDataPackage(products, true)
  });
  $("body").on("click", ".product-details .see-details a", (e) => {
    let uid = getCookie(GLOBAL_CONSTANTS.UID), url = $(e.currentTarget).attr("href");
    let params = {
      ...getParamUrl(),
      uid,
    };
    let body = {
      dc_source: "product_detail",
      dc_medium: "view_product_detail",
      dc_content: (productDetail.getPId()),
    }
    apiTracking(params, body);
    if (LocalStorage.isMiniApp() && !LocalStorage.isOldApp()) {
      e.preventDefault();
      MINI_APP.openSite({ url });
    }
  });
  $("body").on("click", ".section-breadcrumb .d-breadcrumb li:first-child a", (e) => {
    if (LocalStorage.isMiniApp() && !LocalStorage.isOldApp()) {
      MINI_APP.postMessage({
        message: MINI_APP.MESSAGE.BACK_HOME,
      });
      e.preventDefault();
    }
  })
  $(".section.section-recommend .view-more .btn-view-more").on("click", function () {
    getProductRecommend(productSearch, true);
  })
  scrollSetup();
  setUpSliderEvent();
}

function initData() {
  let pid = getParamUrl("pid");
  let productId = urlToId(window.location.pathname.replace("/p/", ""), "p") + "";
  getData(pid || productId);
}

function getData(id, par = {}, productVariant) {
  let params = par;
  if (!productVariant) {
    params = {
      ...params,
      "dc_source": getParamUrl("dc_source") || undefined,
      "dc_medium": "product_detail",
      "dc_content": id,
    }
  }
  if (isFirst) startLoading();

  apiGetProductDetail(id, params, function (data) {
    if (data?.data) {
      let product = SearchProduct.fromApiObject(data.data);

      // GA log view product
      GA.logViewItem({
        items: [{
          "item_id": product.sku || product.getPId() || undefined,
          "item_name": product.meta.title,
        }],
        source: "dc_product_detail",
      });
      FA.logViewItem({
        items: [{
          "item_id": product.sku || product.getPId() || undefined,
          "item_name": product.meta.title,
        }],
        sku: product.sku || product.getPId() || undefined,
        type: "product",
        source: "dc_product_detail",
      });

      productDetail = product;
      fillData(product, productVariant);
      addConfigData(product, productVariant);
      if (!productVariant) {
        productOrigin = product;
        getProductVariants(product.pid || id);
      } else {
        const url = changeQueryString("pid", product.getPId());
        historyPushState(url, true);
        product.getPId() && LocalStorage.addLastProduct(product.getPId());
      }
      estimatePrice(productVariant, product);
      if (isFirst) {
        let productId = urlToId(window.location.pathname, "p") + "";
        getSearchProduct(product.pid || productId);
        isFirst = false;

        if (isMobile()) {
          header.addMemuMobile([
            {
              id: "available_store",
              label: "menu_availableStores",
              icon: require("../../assets/images/menu/Stores.svg"),
              iconHover: require("../../assets/images/menu/Stores_Orange.svg"),
              href: ROOT_GLOBAL.AVAILABLE_STORES,
              isRedirect: true,
            },
            {
              id: "share_link",
              label: "menu_shareLink",
              icon: require("../../assets/images/menu/share.svg"),
              iconHover: require("../../assets/images/menu/shareOrange.svg"),
              onClick: () => {
                copyLinkProductDetail();
              },
            },
          ]);
        }
      }
      $(".section-content").removeClass("loading");
    } else {
      $(".main-page").addClass("no-result");
    }
  }, function (error) {
    if (!productVariant) {
      $(".main-page").addClass("no-result");
    } else {
      fillData(productDetail, productVariant);
    }
  })
}

/**
 * 
 * @param {SearchProduct} product 
 */
function fillData(product = {}, isChangeDimension = false) {
  if (!isEmpty(product.meta?.images)) {
    setUpSliderImage(product.meta.images, isChangeDimension);
  } else {
    if (!isChangeDimension) {
      let img = product.meta?.image || (LocalStorage.getLanguage() === "vi" ? require("../../assets/images/search/img_default_vi.jpg") : require("../../assets/images/search/img_default_en.jpg"));
      $(".section-content .product-info .product-image .product-summary-image .image").css('background-image', `url(${optimizeImage(img, 960)})`);
      $(".section-content .product-info .product-image .product-thumbnail.desktop").addClass("hide");
    }
  }
  if (!isChangeDimension) {
    $(".section-content .product-info .product-infomation .site-info .site-name").text(product.site?.name);
    $(".section-content .product-info .product-infomation .site-info .site-logo").attr("src", "https://www.google.com/s2/favicons?sz=32&domain=" + product.site?.domain);
    $(".section-content .product-info .product-infomation .product-name").text(product.meta?.title);
    if (product.meta?.color) {
      $(".section-content .product-info .product-infomation .product-details .color .value").html(product.meta?.color);
      $(".section-content .product-info .product-infomation .product-details .color").removeClass("hide");
    }
    if (product.meta?.size) {
      $(".section-content .product-info .product-infomation .product-details .size .value").html(product.meta?.size);
      $(".section-content .product-info .product-infomation .product-details .size").removeClass("hide");
    }
    if (product.meta?.description && typeof (product.meta.description) === "string") {
      let description = formatDescription(product.meta.description);
      if (description) {
        $(".section-content .product-description .content-description .value").html(description);
        $(".product-description").removeClass("hide");
      }
    } else {
      $(".product-description").addClass("hide");
    }

    if (LocalStorage.hasExtension() || isMobileByWidth()) {
      $(".section-content .product-info .product-infomation .required-install").addClass("hide");
    } else {
      $(".section-content .product-info .product-infomation .required-install").removeClass("hide");
    }

    $(".section-breadcrumb .d-breadcrumb li.active .link-item span").text(product.meta?.title);
  }

  setProductPrice(product.checkoutPrice, product.checkoutCur);
  setUnitPrice(product.unitPrice, product.unitCur);

  let url = "";
  if (LocalStorage.isMiniApp()) {
    url = product.meta?.currentUrl;
  } else {
    url = LocalStorage.hasExtension() ? product.meta?.currentUrl : `${ROOT_GLOBAL.SHORT_LINK_PRODUCT}${product.getPId()}?product_id=${product.getPId()}`;
    if (isMobileByWidth()) {
      $(".section-content .product-info .product-infomation .see-details span").attr("data-i18n", "productDetail_seeProductDetailsInApp");
      $(".section-content .product-info .product-infomation .see-details span").text($.i18n("productDetail_seeProductDetailsInApp"));
    }
  }
  $(".section-content .product-info .product-infomation .see-details a").attr("href", urlFullFill(url));

  // if (!isMobileByWidth()) {
  //   onHoverImage(product);
  // }
}

function formatDescription(description) {
  let showMoreRegex = /(<a[^>]*>)*(Show more)*/gi;
  let hrefRegex = /(<a[^>]*href=")[^"]*("[^>]*>)/gi;
  let scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  return description.replace(scriptRegex, "").replace(showMoreRegex, "").replace(hrefRegex, "");
}

function setUpSliderImage(images = [], isChangeDimension) {
  currentImageIndex = 0;
  $(".section-content .product-info .product-image .product-thumbnail.desktop").removeClass("hide");
  $(".section-content .product-info .product-image .product-thumbnail .flex-box").html("");
  if (isChangeDimension && $(".section-content .product-info .product-image .product-thumbnail.is-slider .flex-box").hasClass("slick-slider")) {
    $(".section-content .product-info .product-image .product-thumbnail.is-slider .flex-box").slick("unslick");
  }
  let htmlImages = "", imgSummary = "";
  images.forEach((element, index) => {
    htmlImages += `
        <div class="item-thumbnail${index === 0 ? " active" : ""}" index="${index}" image="${element.large}">
          <img alt="thumb-image" src='${optimizeImage(addSlashes(element.thumb || element.large), 112, false)}' />
        </div>
      `
    if (!imgSummary) imgSummary = element.large;
  });
  $(".section-content .product-info .product-image .product-summary-image .image").css('background-image', `url(${optimizeImage(imgSummary, 960)})`);
  window.hasSlider = images.length > 5;
  if (window.hasSlider) {
    $(`.section-content .product-info .product-image .product-summary-image .div-image`).addClass("has-slider");
  } else {
    $(`.section-content .product-info .product-image .product-summary-image .div-image`).removeClass("has-slider");
  }
  $(".section-content .product-info .product-image .product-thumbnail .flex-box").html(htmlImages);

  setUpSlider();
  setUpHover();
}

function optimizeImage(image = "", width = "auto", isEscape = true) {
  if (!image) return image;

  if (image.includes(Env.DUTY_CAST_IMGFOE_URL)) {
    image = `${image}${image.indexOf('?') !== -1 ? '&' : '?'}max-w=${width}`
  }

  return isEscape ? CSS.escape(image) : image;
}

function setUpSlider() {
  $(".section-content .product-info .product-image .product-thumbnail.is-slider .flex-box").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    accessibility: false,
    lazyLoad: 'ondemand',
    // vertical: true,
    // verticalSwiping: true,
    // swipeToSlide: true,
    // prevArrow: false,
    // nextArrow: false,
    vertical: false,
    verticalSwiping: false,
    swipeToSlide: true,
    nextArrow: `<img class="slick-next slick-arrow" alt="icon" src="${require("../../assets/images/icons/Arrow_Right_Orange.svg")}" />`,
    prevArrow: `<img class="slick-prev slick-arrow" alt="icon" src="${require("../../assets/images/icons/Arrow_Left_Orange.svg")}" />`,
    // responsive: [
    //   {
    //     breakpoint: 1023,
    //     settings: {
    //       vertical: false,
    //       verticalSwiping: false,
    //       swipeToSlide: true,
    //       nextArrow: `<img class="slick-next slick-arrow" alt="icon" src="${require("../../assets/images/icons/Arrow_Right_Orange.svg")}" />`,
    //       prevArrow: `<img class="slick-prev slick-arrow" alt="icon" src="${require("../../assets/images/icons/Arrow_Left_Orange.svg")}" />`,
    //     }
    //   },
    // ]
  });

  $(".section-content .product-info .product-image .product-thumbnail.is-slider .flex-box").off("beforeChange");
  $(".section-content .product-info .product-image .product-thumbnail.is-slider .flex-box").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    let currentSlider = $(event.currentTarget).find(`.item-thumbnail[data-slick-index=${nextSlide}]`);
    $(".section-content .product-info .product-image .product-summary-image .image").css('background-image', `url(${optimizeImage(currentSlider.attr("image"), 960)})`);
  })
}

function setUpHover() {
  $(".section-content .product-info .product-image .product-thumbnail.no-slider .item-thumbnail").off("mouseenter");
  $(".section-content .product-info .product-image .product-thumbnail.no-slider .item-thumbnail").on("mouseenter", function (e) {
    setCurrentImage($(this));
  })
}

function setUpSliderEvent() {
  $(".section-content .product-info .product-image .product-summary-image .icon-slider.previous").on("click", function () {
    if (window.hasSlider) {
      $(".section-content .product-info .product-image .product-thumbnail.is-slider .flex-box").each(function (i, obj) {
        $(obj).slick('slickPrev');
      });
    }
  })
  $(".section-content .product-info .product-image .product-summary-image .icon-slider.next").on("click", function () {
    if (window.hasSlider) {
      $(".section-content .product-info .product-image .product-thumbnail.is-slider .flex-box").each(function (i, obj) {
        $(obj).slick('slickNext');
      });
    }
  })

  $("body").on("click", ".section-content .product-info .product-image .product-thumbnail.is-slider .item-thumbnail", function (e) {
    let sliderIndex = $(e.currentTarget).attr("data-slick-index");
    if (window.hasSlider) {
      $(".section-content .product-info .product-image .product-thumbnail.is-slider .flex-box").each(function (i, obj) {
        $(obj).slick("slickGoTo", sliderIndex);
      });
    } else {
      setCurrentImage($(this), true);
    }
  })

  $("body").on("click", ".section-content .product-info .product-image .product-thumbnail.no-slider .item-thumbnail", function (e) {
    setCurrentImage($(this));
    currentImageIndex = $(this).attr("index");
  })

  $("body").on("mouseleave", ".section-content .product-info .product-image .product-thumbnail.no-slider", function (e) {
    let currentImage = $(`.section-content .product-info .product-image .product-thumbnail.no-slider .item-thumbnail[index="${currentImageIndex}"`);
    setCurrentImage(currentImage);
  })
}

function setCurrentImage(element, isSlider = false) {
  $(".section-content .product-info .product-image .product-summary-image .image").css('background-image', `url(${optimizeImage(element.attr("image"), 960)})`);
  if (!isSlider) {
    $(".section-content .product-info .product-image .product-thumbnail.no-slider .item-thumbnail").removeClass("active");
    element.addClass("active");
  } else {
    $(".section-content .product-info .product-image .product-thumbnail.is-slider .item-thumbnail").removeClass("slick-current");
    let sliderIndex = element.attr("data-slick-index");
    $(`.section-content .product-info .product-image .product-thumbnail.is-slider .item-thumbnail[data-slick-index=${sliderIndex}]`).addClass("slick-current");
  }
}

function setUnitPrice(price, currency) {
  if (price && currency) {
    $(".section-content .product-info .product-infomation .unit-price .value").html(getPriceText(price, currency));
    $(".section-content .product-info .product-infomation .unit-price").removeClass("hide");
  } else {
    $(".section-content .product-info .product-infomation .unit-price").addClass("hide");
  }
}

function setProductPrice(price, currency) {
  $(".section-content .product-info .product-infomation .product-details .price").removeClass("hide");
  $(".section-content .product-info .product-infomation .see-details").addClass("has-price");
  if (price && currency) {
    const text = getPriceText(price, currency);
    $(".section-content .product-info .product-infomation .product-details .price .value").html(text);
    $(".section-content .product-info .product-infomation .product-details .price .value").attr("data-i18n", "");
    $(".section-content .product-info .product-infomation .see-details").removeClass("updating");
    // $(".section-content .product-info .product-infomation .product-details .price").removeClass("hide");
    productDetail?.detailUrl && defer(() => !!fastCheckoutBtn, () => {
      fastCheckoutBtn.setPrice(text);
      fastCheckoutBtn.show();
    });
  } else {
    // $(".section-content .product-info .product-infomation .product-details .price").addClass("hide");
    $(".section-content .product-info .product-infomation .product-details .price .value").html($.i18n("productDetail_priceUpdating"));
    $(".section-content .product-info .product-infomation .product-details .price .value").attr("data-i18n", "productDetail_priceUpdating");
    $(".section-content .product-info .product-infomation .see-details").addClass("updating");
    fastCheckoutBtn && fastCheckoutBtn.hide();
  }
}

/** 
 * @param {Variant} productVariant
 * @param {SearchProduct} product
 * */
function estimatePrice(productVariant, product) {
  let maxCount = Env.DUTY_CAST_MAX_ESTIMATE_PRICE_TIME ? parseInt(Env.DUTY_CAST_MAX_ESTIMATE_PRICE_TIME) : 30;
  let count = productVariant ? maxCount - 2 : 0;
  const loop = () => {
    count += 1;
    if (count < maxCount) {
      let params = {};
      productVariant ? params = genParamsEstimate(productVariant.sku, productVariant.siteId, productVariant.url) : params = genParamsEstimate(product.sku, product.site?.id, product.meta?.currentUrl)
      apiEstimateProductPrice(params,
        function (data) {
          if (data?.data) {
            let order = Order.fromApiObject(data.data);
            if (!productVariant) {
              if ((order.payAmount && order.payCurrency)) {
                setProductPrice(order.payAmount, order.payCurrency);
                productOrigin.checkoutPrice = order.payAmount;
                productOrigin.checkoutCur = order.payCurrency;
                let sitePrice = order.details[0] ? order.details[0].sitePrice : 0;
                let sitePriceCur = order.details[0] ? order.details[0].sitePriceCur : "";
                setUnitPrice(sitePrice && sitePriceCur ? sitePrice : productOrigin.unitPrice, sitePrice && sitePriceCur ? sitePriceCur : productOrigin.unitCur);
                getPriceTags(order);
              } else {
                estimateTimeout = setTimeout(() => {
                  loop();
                }, Env.DUTY_CAST_ESTIMATE_PRICE_DELAY || 3000);
              }
            } else {
              // setProductPrice(order.payAmount && order.payCurrency ? order.payAmount : productOrigin.checkoutPrice, order.payAmount && order.payCurrency ? order.payCurrency : productOrigin.checkoutCur);
              setProductPrice(order.payAmount, order.payCurrency);
              let sitePrice = order.details[0] ? order.details[0].sitePrice : 0;
              let sitePriceCur = order.details[0] ? order.details[0].sitePriceCur : "";
              setUnitPrice(sitePrice && sitePriceCur ? sitePrice : productOrigin.unitPrice, sitePrice && sitePriceCur ? sitePriceCur : productOrigin.unitCur);
              getPriceTags(order);
            }
          }
        }
      )
    }
  }
  loop();
}

/** @param {Order} order */
function getPriceTags(order = {}) {
  if (!order.details?.length) return;
  let params = Product.getParamPriceTags(order.details);
  apiGetPriceTags(params,
    function (data) {
      let priceTags = PriceTag.fromApiArray(data.data);
      setLowestPrice(priceTags);
    },
    function () {
      setLowestPrice([]);
    }
  )
}

function setLowestPrice(priceTags = []) {
  if (!priceTags.length) return;
  let temp = priceTags[0];
  showLowestPriceTags((temp?.tags || []).length > 0);
  temp?.tags && lowestTag.setPriceTags(temp.tags);
}

function showLowestPriceTags(isLowestPrice = false) {
  $(".section-content .product-info .product-infomation .unit-price").toggleClass("is-lowest-price", isLowestPrice);
}

function genParamsEstimate(sku, siteId, currentUrl) {
  let params = {
    "details": []
  };
  let pid = getParamUrl("pid");
  if (sku && siteId) {
    let query = {
      "sku": sku,
      "site_id": siteId,
      "product_provider_id": pid || productDetail.getPId()
    }
    if (currentUrl) {
      query["meta"] = {
        "current_url": currentUrl
      }
    }
    params.details.push(query)
  }
  return params;
}

function getProductVariants(pId) {
  apiGetProductVariants(pId, {},
    function (data) {
      if (data) {
        let productVariant = ProductVariant.fromApiObject(data);
        if (productVariant?.dimensions?.length && productVariant?.variants?.length) {
          productVariant.dimensionKeys.forEach(element => {
            curDimension[element] = "";
          });
          fillDataVariant(productVariant);
        }
        productDetail.getPId() && LocalStorage.addLastProduct(productDetail.getPId());
      }
    }
  )
}

/** @param {ProductVariant} productVariant */
function fillDataVariant(productVariant) {
  let defaultVariant = getCurrentVariant(productVariant.variants, productDetail.sku);
  let sortedDimensions = [];
  for (let i = 0; i < productVariant.dimensionKeys.length; i++) {
    const dimensionKey = productVariant.dimensionKeys[i];
    for (let j = 0; j < productVariant.dimensions.length; j++) {
      const element = productVariant.dimensions[j];
      if (element.dimensionCode === dimensionKey) {
        sortedDimensions.push(element);
      }
    }
  }

  sortedDimensions.forEach(element => {
    let curValue = defaultVariant?.dimensions && Object.keys(defaultVariant.dimensions).length && defaultVariant.dimensions[element.dimensionCode];
    if (curDimension[element.dimensionCode] !== undefined) {
      curDimension[element.dimensionCode] = curValue || "";
    }
    if (element.values.length) {
      dimensionItems[element.dimensionCode] = new DimensionItem({
        parent: ".product-attribues",
        dimension: element,
        currentValue: curValue,
        onClick: (dimensionCode, dimensionValue) => {
          clearTimeout(estimateTimeout);
          if (curDimension[dimensionCode] !== undefined) {
            curDimension[dimensionCode] = dimensionValue;
          }
          setActiveDimensions(productVariant.variants, dimensionCode);
          let temp = getCurrentVariant(productVariant.variants, undefined, curDimension);
          if (temp && temp.sku && temp.siteId && temp.url) {
            getData(temp.productId || 0, {
              sku: temp.sku,
              site_id: temp.siteId,
            }, temp);
          } else {
            fillData(productDetail, true);
          }
        }
      })
    }
  });

  defer(() => !isLoadingDimension(dimensionItems, productVariant.dimensions), () => {
    setActiveDimensions(productVariant.variants, sortedDimensions[0].dimensionCode);
  })
}

function isLoadingDimension(dimensionItems, dimensions) {
  let isLoading = false;
  if (Object.keys(dimensionItems).length !== dimensions.length) return true;

  Object.keys(dimensionItems).forEach(key => {
    if (dimensionItems[key].getLoading()) {
      isLoading = true;
      return true;
    }
  });

  return isLoading;
}

/** @param {[Variant]} variants */
function setActiveDimensions(variants, selectedDimensionCode) {
  let activeDim = activeDimensions(variants, { selectedDimension: curDimension, selectedDimensionCode: selectedDimensionCode });
  Object.keys(dimensionItems).forEach(key => {
    dimensionItems[key].setActiveDimensions(activeDim);
  });
  Object.keys(activeDim.selectedDimension).forEach(key => {
    curDimension[key] = activeDim.selectedDimension[key];
  });
}

/** @param {[Variant]} variants */
function activeDimensions(variants, activeDim) {
  if (!activeDim.selectedDimensionCode) {
    return activeDim;
  }

  let selectedDimension = activeDim.selectedDimension;
  if (!selectedDimension) {
    selectedDimension = variants[0].dimensions;
  }
  const dimensionKeys = Object.keys(selectedDimension);
  dimensionKeys.forEach(key => {
    if (!activeDim[key]) {
      activeDim[key] = {};
    }
  });

  let isMatch = false;
  let activedVariants = activeVariants(variants, activeDim.selectedDimensionCode, selectedDimension[activeDim.selectedDimensionCode]);
  activedVariants.forEach(element => {
    dimensionKeys.forEach(k => {
      activeDim[k][element.dimensions[k]] = true;
    });
    if (isMatchDimension(element.dimensions, selectedDimension)) {
      isMatch = true;
    }
  });

  let reassignSelectedDimension = false;
  for (let index = 0; index < variants.length; index++) {
    const element = variants[index];
    if (!isMatch && !reassignSelectedDimension && element.dimensions[activeDim.selectedDimensionCode] === selectedDimension[activeDim.selectedDimensionCode]) {
      activeDim.selectedDimension = element.dimensions;
      reassignSelectedDimension = true;
    }

    let selectedDimensionMatch = true;
    dimensionKeys.forEach(k => {
      if (k !== activeDim.selectedDimensionCode && !activeDim[k][element.dimensions[k]]) {
        selectedDimensionMatch = false;
      }
    });
    if (selectedDimensionMatch) {
      activeDim[activeDim.selectedDimensionCode][element.dimensions[activeDim.selectedDimensionCode]] = true;
    }
    element.productId && LocalStorage.removeLastProduct(element.productId);
  }

  return activeDim;
}

/** @param {[Variant]} variants */
function activeVariants(variants, selectedDimensionCode, selectedDimensionValue) {
  let result = [];
  variants.forEach(element => {
    if (element.dimensions && Object.keys(element.dimensions).length && element.dimensions[selectedDimensionCode] === selectedDimensionValue && element.isAvailable) {
      result.push(element);
    }
  });
  return result;
}

/**
 * @param {[Variant]} variants 
 * @returns {Variant}
 */
function getCurrentVariant(variants, sku, curDimension = {}) {
  let len = variants.length, defaultVar = {};
  for (let index = 0; index < len; index++) {
    const element = variants[index];
    if (!Object.keys(defaultVar).length && Object.keys(element.dimensions).length) {
      defaultVar = element;
    }
    if (isMatchVariant(element, sku, curDimension)) {
      return element;
    }
  }
  if (0 < len) {
    return defaultVar;
  }
  return {};
}

/** @param {Variant} compareVariant */
function isMatchVariant(compareVariant, sku, curDimension) {
  if (!Object.keys(compareVariant.dimensions).length) {
    return false;
  }
  if (sku && compareVariant.sku === sku) {
    return true;
  }

  if (isMatchDimension(compareVariant.dimensions, curDimension)) {
    return true;
  }

  return false;
}

/** @param {Variant} compareDimension */
function isMatchDimension(compareDimension, curDimension) {
  let keys = Object.keys(compareDimension);
  if (!compareDimension || keys.length === 0) {
    return false;
  }
  if (!curDimension || Object.keys(curDimension).length === 0) {
    return false;
  }

  for (let index = 0; index < keys.length; index++) {
    const key = keys[index];
    if (String(compareDimension[key]) !== String(curDimension[key])) {
      return false;
    }
  }
  return true;
}

function getSearchProduct(productId) {
  let params = {
    ...genParamsSearch(),
    "pp": 1,
    "f": {
      "id": [productId]
    },
    "dc_medium": "product_detail",
    "dc_content": productId,
  };
  apiGetProductSearch(params, function (data) {
    if (data?.data?.length) {
      let product = SearchProduct.fromApiObject(data.data[0]);
      productSearch = product;
      if (product?.meta?.t) {
        getProductRecommend(product);
      } else {
        stopLoading();
        $(".section.section-recommend").addClass("hide");
      }
    } else {
      stopLoading();
      $(".section.section-recommend").addClass("hide");
    }
  }, function (error) {
    stopLoading();
    $(".section.section-recommend").addClass("hide");
  })
}

/** @param {SearchProduct} product */
function getProductRecommend(product, isLoadmore = false) {
  if (isLoadmore) {
    page += 1;
  }
  let params = {
    ...genParamsSearch(),
    "p": page,
    "pp": DEFAULT_PER_PAGE_SEARCH,
    "t": product.meta.t,
    "f": {
      "id_neq": [product?.getPId()]
    },
    "dc_medium": "product_recommend",
    "dc_content": product?.getPId(),
  };
  if (isLoadmore) startLoading();
  apiGetProductSearch(params, function (data) {
    // apiGetProductPackage(id, function (data) {
    let searchData = Search.fromApiObject(data);
    if (searchData.products.length) {
      fillDataSearch(searchData);
      estimateProductPrice(genParamsEstimateMultiple(searchData.products));
      stopLoading();
      $(".section.section-recommend").removeClass("hide");
    } else {
      stopLoading();
      $(".section.section-recommend").addClass("hide");
    }
  },
    function (error) {
      stopLoading();
      $(".section.section-recommend").addClass("hide");
    }
  )
}

function estimateProductPrice(params) {
  let ids = params.pids;
  apiEstimateProductPriceMultiple(params.params,
    function (data) {
      if (data?.data) {
        let orders = Order.fromApiArray(data.data);
        if ((orders.length)) {
          for (let index = 0; index < ids.length; index++) {
            const productId = ids[index];
            const order = orders[index];
            let product = listProductItems.find(item => item.getId() === productId);
            if (product) {
              product.element.attr("estimated", true);
              product.setProductPrice(order.payAmount, order.payCurrency);
              let sitePrice = order.details[0] ? order.details[0].sitePrice : 0;
              let sitePriceCur = order.details[0] ? order.details[0].sitePriceCur : "";
              product.setUnitPrice(sitePrice, sitePriceCur);
            }
          }
        }
      }
    }
  )
}

/** @param {Search} searchData */
function fillDataSearch(searchData) {
  searchData.products.forEach(element => {
    listProductItems.push(new SearchProductItem({
      parent: ".section.section-recommend .search-data",
      product: element,
      source: Search.SOURCE.RECOMMEND
    }))
  });
  let count = searchData.paging?.currentPage * DEFAULT_PER_PAGE_SEARCH, total = searchData.paging?.totalCount;
  let products = count < total ? count : total;

  if (searchData.paging?.currentPage < searchData.paging?.totalPages) {
    $(".section.section-recommend .view-more .value").html(`(${total - products})`);
    $(".section.section-recommend .view-more").removeClass("hide");
  } else {
    $(".section.section-recommend .view-more").addClass("hide");
  }
}

function genParamsSearch() {
  let params = {
    "p": 1,
    "pp": DEFAULT_PER_PAGE_SEARCH,
    "fl": 0,
    "i": Env.DUTY_CAST_EXTENSION_SEARCH_INDEX,
    "dt": ["product"],
    "f": {},
    "t": {},
    "dc_source": getParamUrl("dc_source") || undefined
  };
  return params;
}

/**
 * 
 * @param {[SearchProduct]} products 
 * @returns 
 */
function genParamsEstimateMultiple(products = []) {
  let params = {
    "details": []
  };
  let listPro = []
  products.forEach(product => {
    let query = {
      "site_id": product?.site?.id || "",
      "product_provider_id": product.getPId()
    }
    params.details.push(query);
    listPro.push(product.getPId());
  });

  return {
    params: params,
    pids: listPro
  }
}

function fillDataPackage(data = [], isLoadmore = false) {
  if (isLoadmore) {
    packageItems.addData(data, true);
  } else {
    packageItems = new PackageList({
      parent: ".section-compare .compare-list",
      dataTable: data
    })
  }
}

// function onHoverImage(product) {
//   let img = $(`.section-content .product-info .product-image .product-summary-image .div-image`);
//   let preview = $(`.section-content .product-info .product-image .product-summary-image .img-magnifier-container`);

//   let zoom = preview.width() / 100;

//   img.on("mousemove", (e) => {
//     preview.css("background-image", `url(${product.meta?.image})`);
//     preview.css("background-size", (img.width() * zoom) + "px " + (img.height() * zoom) + "px");
//     let posX = e.pageX - $(e.currentTarget).offset().left,
//       posY = e.pageY - $(e.currentTarget).offset().top,
//       imgWidth = img.width(),
//       imgHeight = img.height(),
//       xperc = (posX / imgWidth) * 100,
//       yperc = (posY / imgHeight) * 100;
//     // Add some margin for right edge
//     if (posX > 0.01 * imgWidth) {
//       xperc += 0.15 * xperc;
//     }

//     // Add some margin for bottom edge
//     if (posY >= 0.01 * imgHeight) {
//       yperc += 0.15 * yperc;
//     }
//     preview.css("background-position", `${xperc - 9}% ${yperc - 9}%`);
//   });
//   img.on("mouseout", () => {
//     preview.css("background-image", "none");
//   });
// }

function startLoading() {
  $(".section.section-recommend").addClass("loadmore");
}

function stopLoading() {
  $(".section.section-recommend").removeClass("loadmore");
  $(".section.section-recommend").removeClass("loading");
}

function scrollSetup() {
  $(window).scroll(function () {
    if ($(window).width() > 1023) {
      const top = $(window).scrollTop();
      let more = $('.product-info');
      let productImage = $('.product-image .image');
      if (more.height() > productImage.height() + 100) {
        if (top + 72 >= more[0].offsetTop) {
          if (top <= more[0].offsetHeight - productImage.height() - 12) {
            $(".product-info .product-image").css("width", $(".product-info .product-infomation").outerWidth());
            $(".product-info").addClass("sticky").removeClass("absolute");
          } else {
            $(".product-info").addClass("absolute");
          }
        } else {
          $(".product-info .product-image").css("width", "50%");
          $(".product-info").removeClass("sticky").removeClass("absolute");
        }
      } else {
        $(".product-info").removeClass("sticky").removeClass("absolute");
      }
    } else {
      $(".product-info .product-image").css("width", "100%");
      $(".product-info").removeClass("sticky").removeClass("absolute");
    }
  });
  $(window).on('resize', () => {
    if ($(window).width() > 1023) {
      $(".product-info .product-image").css("width", $(".product-info .product-infomation").outerWidth());
    } else {
      $(".product-info .product-image").css("width", "100%");
      $(".product-info").removeClass("sticky").removeClass("absolute");
    }
  });
}

/** @param {SearchProduct} product */
function addConfigData(product, variant) {
  $("body product").remove();
  if (!product.detailUrl) {
    if (container) {
      container.remove();
    }
    return;
  }
  const element = $("<product></product>");
  element.attr("sku", product.sku);
  element.attr("product_provider_id", product.getPId());
  element.attr("site_id", product.site.id);
  element.attr("title", product.meta.title);
  if (product.unitPrice) {
    element.attr("unit_price", product.unitPrice);
  }
  if (product.unitCur) {
    element.attr("unit_cur", product.unitCur);
  }
  element.attr("image", product.meta.image ?? getOr(undefined, "meta.images[0].large")(product) ?? getOr(undefined, "meta.images[0].thumb")(product), getOr(undefined, "meta.images[0].high_res")(product));
  element.attr("color", product.meta.color);
  element.attr("size", product.meta.size);
  $("body").append(element);
  if (!LocalStorage.hasExtension() && !container) {
    container = $(`<div style="z-index: 2147483647 !important; display: block !important; visibility: visible !important; position: relative !important;"></div>`);
    $('body').append(container);
    const shadow = container[0].attachShadow({ mode: "open" });
    root = $(`<root></root>`);
    const className = classNames({
      "dutycastWP": true,
      "notranslate": true,
      "touch-device": isTouchDevice()
    });
    const html = `
      <div id="dutycastWP" class="${className}">
        <div id="fCheckoutBtnWP"></div>
      </div>
    `;
    root.append($(html));
    shadow.appendChild(root[0]);
    loadStyle();
    loadFont();
    initAddCartButton("expandItem", GLOBAL_CONSTANTS.SITE_STATE.PUBLISHED);
    initCheckoutButton("expandItem", GLOBAL_CONSTANTS.SITE_STATE.PUBLISHED);
    initFastCheckout();
    setOrderData();
  }
}


async function setOrderData() {
  if (currentOrderCode) {
    FireBase.stopGetUpdateOrder(currentOrderCode);
  }
  const order = await getOrder();
  if (order?.code) {
    currentOrderCode = order?.code;
    let firstTime = true;
    FireBase.getUpdatedOrder(order?.code, () => {
      if (!firstTime) {
        setOrderData();
      }
      firstTime = false;
    })
    const badge = Order.getBadge(order);
    if (badge.number > 0) {
      checkoutBtn.setNotEmpty(true);
      checkoutBtn.setBadge(badge.text);
      return;
    }
  }
  checkoutBtn.setNotEmpty(false);
  checkoutBtn.setBadge("");
}

function initAddCartButton(collapse, state) {
  const addIcon = require("../../assets/images/float_button/add.svg");
  const addedIcon = require("../../assets/images/float_button/added.svg");
  const collapseIcon = require("../../assets/images/float_button/icon-collapse.svg");
  const arrowCollapse = require("../../assets/images/float_button/arrow_collapse.svg");
  const arrowExpand = require("../../assets/images/float_button/arrow_expand.svg");
  const dragIcon = require("../../assets/images/float_button/drag.svg");

  const textDutycastCart = $.i18n("content_dutycastCart");
  const textAddTo = $.i18n("content_addTo");
  const textAddToHide = $.i18n("content_welcome");
  const textHide = $.i18n("content_welcomeMessage");
  const textAddToDraft = $.i18n("content_draft");
  const textDraft = $.i18n("content_draftMessage");

  addToCartBtn = AddToCartBtn.init({
    parent: root.find("#dutycastWP"),
    className: collapse,
    textAddTo,
    textDutycastCart,
    textAddToHide,
    textHide,
    textAddToDraft,
    textDraft,
    addIcon,
    addedIcon,
    collapseIcon,
    arrowCollapse,
    arrowExpand,
    dragIcon,
    state,
    onCollapse: (value, originalEvent) => {
      tracking({
        action: "collapse",
        state: "checkout"
      });
      checkoutBtn && checkoutBtn.collapse(value);
    },
    onClick: (e) => {
      addToCart();
    }
  });
}

function initCheckoutButton(collapse, state) {
  const cartIcon = require("../../assets/images/float_button/cart.svg");
  const arrowIcon = require("../../assets/images/float_button/arrow.svg");
  const dragIcon = require("../../assets/images/float_button/drag.svg");

  const textCheckout = $.i18n("content_checkout");
  checkoutBtn = CheckoutBtn.init({
    parent: root.find("#dutycastWP"),
    className: collapse,
    textCheckout,
    arrowIcon,
    cartIcon,
    dragIcon,
    state,
    onClick: async () => {
      tracking({
        action: "checkout",
        state: "checkout"
      });
      checkout();
    }
  });
}

function initFastCheckout() {
  const title = $.i18n("common_buyNow");
  const fastCheckoutLogo = require("../../assets/images/float_button/fast-cart.svg");
  const closeIcon = require("../../assets/images/float_button/close.svg");
  const dragIcon = require("../../assets/images/float_button/drag.svg");
  fastCheckoutBtn = FastCheckoutBtn.init({
    parent: root.find("#fCheckoutBtnWP"),
    price: "",
    title: title,
    logo: fastCheckoutLogo,
    closeIcon: closeIcon,
    dragIcon: dragIcon,
    language: LocalStorage.getLanguage(),
    onCheckout: () => {
      fastCheckoutBtn && fastCheckoutBtn.animation();
      tracking({
        action: "checkoutFastCheckout"
      });
      addToCart(fastCheckoutBtn);
    },
    onClose: () => {
      fastCheckoutBtn && fastCheckoutBtn.hide();
    }
  });
}

function loadStyle() {
  const style = document.createElement("style");
  style.textContent = require("!!css-loader!resolve-url-loader!sass-loader!./cart.scss").toString();
  root.append(style);
}

function loadFont() {
  const style = document.createElement("style");
  style.textContent = require("!!css-loader!resolve-url-loader!sass-loader!../../global/font.scss").toString();
  root.append(style);
}

async function addToCart(fastCheckout) {
  if (!addToCartBtn) {
    return;
  }
  addToCartBtn.disableUI();
  addToCartBtn.disableClick();
  if (!fastCheckout) {
    addToCartBtn.added(true);
    checkoutBtn.animation(true);
    addToCartBtn.added(true);
    setTimeout(() => {
      addToCartBtn.added(false);
      checkoutBtn.animation(false);
      addToCartBtn.disableClick(false);
    }, 1600);
  }
  fastCheckout && fastCheckout.disable();

  tracking({
    action: fastCheckout ? "fastCheckout" : "addToCart",
    state: "add"
  });

  const sku = $("product").attr("sku");
  const site_id = $("product").attr("site_id");
  const product_provider_id = $("product").attr("product_provider_id");
  const title = $("product").attr("title");
  const current_url = window.location.href;
  const image = $("product").attr("image");
  const color = $("product").attr("color");
  const size = $("product").attr("size");
  const unit_price = $("product").attr("unit_price");
  const cur = $("product").attr("unit_cur");
  let quantity = 1;

  if (!sku) {
    addToCartBtn.disableUI(false);
    addToCartBtn.disableClick(false);
    fastCheckout && fastCheckout.enable();
    return;
  }
  const currentOrder = await getOrder();
  if (currentOrder && currentOrder.details) {
    for (let i = 0; i < currentOrder.details.length; i++) {
      const product = currentOrder.details[i];
      if (product.sku === sku) {
        quantity = product.quantity + (fastCheckout ? 0 : 1);
      }
    }
  }

  const params = {
    details: [
      {
        sku,
        site_id,
        product_provider_id,
        meta: {
          title,
          current_url,
          image,
          color,
          size,
        },
        unit_price,
        cur,
        quantity,
      }
    ]
  }

  try {
    await apiAddToCart(params, (response) => {

      // GA log add to cart
      GA.logAddToCart({
        items: {
          "item_id": sku || product_provider_id || undefined,
          "item_name": title,
        },
        orderCode: getOr(undefined, "data.code")(response),
        source: "dc_product_detail",
      });
      FA.logAddToCart({
        items: {
          "item_id": sku || product_provider_id || undefined,
          "item_name": title,
        },
        orderCode: getOr(undefined, "data.code")(response),
        source: "dc_product_detail",
      });

      if (fastCheckout) {
        const order = Order.fromApiObject(getOr(undefined, "data")(response));
        if (order) {
          const newProduct = order.details.find(e => e.sku === sku);
          checkout(newProduct.id, order);
        }
      }
    }, (error) => {
      console.log(error);
      const message = getMessage(error);
      const modal = new ModalDialog({
        type: GLOBAL_CONSTANTS.DIALOG_TYPE.ERROR,
        icon: require("../../assets/images/icons/Error.svg"),
        titleI18n: "checkout_errorTitle",
        descriptionI18n: message,
        btnSubmitI18n: "common_OK",
      });
      modal.show();
    });
  } catch (error) {

  }

  addToCartBtn.disableUI(false);
  addToCartBtn.disableClick(false);
  fastCheckout && fastCheckout.enable();
  setOrderData();
}

/** @returns {Order} */
async function getOrder() {
  let result;
  try {
    await apiGetOrderDetail(
      {},
      function (data) {
        if (data && data.data && data.data.details && data.data.details.length) {
          result = Order.fromApiObject(data.data);
        }
      },
      () => {

      }
    );
  } catch (error) {
    return result;
  }
  return result;
}

function tracking(body = {}) {
  let uid = getCookie(GLOBAL_CONSTANTS.UID), url = window.location.href;
  let params = {
    ...getParamUrl(),
    url,
    uid,
  };
  apiTracking(params, body);
}

async function checkout(pID, order) {
  checkoutBtn.disable(true);
  checkoutBtn.animation(true);
  if (!order) {
    order = await getOrder();
  }
  if (order.details.length === 0) {
    checkoutBtn.disable(false);
    checkoutBtn.animation(false);
    return;
  }
  const uid = getCookie(GLOBAL_CONSTANTS.UID);
  const cks = genCKS(uid, order.code);
  const fastParam = pID ? `&m=fc&pid=${pID}` : "";
  window.open(`${ROOT_GLOBAL.CHECKOUT}/${order.code}?uid=${uid}&cks=${cks}${fastParam}`);
  checkoutBtn.disable(false);
  checkoutBtn.animation(false);
}

function onLanguage(language) {
  if (addToCartBtn) {
    const textDutycastCart = $.i18n("content_dutycastCart");
    const textAddTo = $.i18n("content_addTo");
    const textAddToHide = $.i18n("content_welcome");
    const textHide = $.i18n("content_welcomeMessage");
    const textAddToDraft = $.i18n("content_draft");
    const textDraft = $.i18n("content_draftMessage");
    addToCartBtn.setText(textAddTo, textDutycastCart, textAddToHide, textHide, textAddToDraft, textDraft);
  }
  if (checkoutBtn) {
    checkoutBtn.setText($.i18n("content_checkout"));
  }
  if (fastCheckoutBtn) {
    fastCheckoutBtn.setLanguage(language);
    fastCheckoutBtn.setTitle($.i18n("common_buyNow"));
  }
}

function copyLinkProductDetail() {
  if (!isSetupCopy) {
    // eslint-disable-next-line no-undef
    const clipboard = new Clipboard('#copy_button');

    clipboard.on('success', function (e) {
      setTooltip(e.trigger, 'Copied!');
      hideTooltip(e.trigger);
    });

    clipboard.on('error', function (e) {
      setTooltip(e.trigger, 'Failed!');
      hideTooltip(e.trigger);
    });

  }

  if (LocalStorage.isMiniApp()) {
    MINI_APP.share({ url: window.location.href });
  } else {
    $("#copy_button").attr("data-clipboard-text", window.location.href);
    $("#copy_button").trigger("click");
  }

  isSetupCopy = true;
}